module.exports = __webpack_public_path__ + "static/media/clock.1b94f7b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/noticeboard/clock.svg
// module id = 564
// module chunks = 0